<template>
  <div class = "body">
    <div class="main-container">
      <div class="main-content">
        <slot></slot>
      </div>
    </div>
  </div>

</template>

<script>
	export default {
		name: "PageBody"
	}
</script>

<style scoped>

  .body {
    width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
	}

	.main-container {
		margin-top: 130px;
    width: 100%;
		display: flex;
		justify-content: center;
    flex: 1;
	}

	.main-content {
		width: 100%;
    //margin-left: -2px;
	}
</style>